import { 
    IMAGE_CROP_SOCIAL_SHARE_MODAL_OPEN, 
    IMAGE_CROP_SOCIAL_SHARE_MODAL_CLOSE 
} from '../constants/actionTypes';

export const imageCropModalOpen = payload => ({
    type: IMAGE_CROP_SOCIAL_SHARE_MODAL_OPEN,
    payload
});

export const imageCropModalClose = () => ({
    type: IMAGE_CROP_SOCIAL_SHARE_MODAL_CLOSE
});
